import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'
import ClientType from '@/helper/ClientType'
import * as ClientPlans from '@/helper/ClientPlans'
import moment from 'moment'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      observation: '',
      clientPlans: ClientPlans,
      dialog: false,
      isLoading: false,
      menuTimePicker: false,
      timepicker: null,
      menuEndDate: false,
      endDate: null,
      endDateFormated: null,
      isLoadingAllClients: false,
      selectedClient: null,
      isLoadingProductPlans: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterAllProductPlans',
      'getterClients'
    ]),
    filteredClients () {
      const filteredList = this.getterClients.filter((item) => item.type !== ClientType.CLIENT_PRE)

      return filteredList || []
    },
    isDisabled () {
      return this.observation === '' || this.endDate === null || this.selectedClient === null || this.timepicker === null
    }
  },
  watch: {
    endDateFormated (val) {
      if (!val) {
        this.endDate = null
      }
    },
    selectedClient (val) {
      if (!val) {
        this.selectedClient = null
      }
    }
  },
  mounted () {
    this.dialog = true

    this.getAllProductPlans()

    this.getAllClients()
  },
  beforeDestroy () {
    this.SET_SELECTED_INVOICE()
  },
  methods: {
    ...mapActions([
      'actionGetAllProductPlans',
      'actionGetAllClients',
      'actionAddInvoice'
    ]),
    ...mapMutations([
      'SET_SELECTED_INVOICE'
    ]),
    formatDateOfDatePicker (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    generateExtractPeriod () {
      const params = {
        closingDay: `${moment(this.endDate).format('YYYY-MM-DD')}T${this.timepicker}:59`,
        settled: false,
        paidValue: 0,
        idUserLogged: this.getterAccount.idUser,
        idClient: this.selectedClient.idClient,
        cnpj: this.selectedClient.cnpj,
        observation: this.observation
      }

      this.isLoading = true

      this.actionAddInvoice(params)
        .then(() => {
          this.closeModal()

          this.sendToast({
            text: 'Fatura gerada com sucesso!',
            type: 'success'
          })
        })
        .catch((error) => {
          this.setTypeOfMessageNotification(error)
        })
    },
    setTypeOfMessageNotification (response) {
      const updatedResponse = Object.prototype.hasOwnProperty.call(response, 'response') ? response.response : response
      const toast = (type = 'danger', text = 'Ocorreu um erro ao gerar a fatura, tente novamente mais tarde!') => this.sendToast({ text, type })

      if (updatedResponse && updatedResponse.data && updatedResponse.data.code) {
        switch (updatedResponse.data.code) {
          case 'EXPLOSIONS_NOT_FOUND':
            toast('warning', 'Nenhuma explosão encontrada para o cliente')
            break
          case 'CALLMANAGERS_NOT_FOUND':
            toast('warning', 'Não foram encontrados callmanagers para criar fatura')
            break
          case 'PRODUCT_RULES_NOT_FOUND':
            toast('warning', 'Regras de fechamento não encontradas para o produto')
            break
          case 'CALL_TREE_SERVICE':
            toast('warning', 'Erro ao chamar o serviço em árvore')
            break
          case 'CALLMANAGERS_MINIMUN_VALUE':
            toast('warning', 'Valor mínimo de callmanagers não aceito')
            break
          default:
            toast()
        }
      } else {
        toast('danger', typeof response === 'string' ? response : toast.text)
      }

      this.isLoading = false
    },
    getAllProductPlans () {
      this.isLoadingProductPlans = true

      this.actionGetAllProductPlans()
        .then(() => {
          this.isLoadingProductPlans = false
        })
        .catch(() => {
          this.isLoadingProductPlans = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os planos do cliente, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    getAllClients () {
      this.isLoadingAllClients = true

      this.actionGetAllClients()
        .then(() => {
          this.isLoadingAllClients = false
        })
        .catch(() => {
          this.isLoadingAllClients = false

          this.sendToast({
            text: 'Não foi possível buscar os clientes',
            type: 'danger'
          })
        })
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
